import { ChangeDetectionStrategy, Component, inject, input, InputSignal, signal} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { RestService } from 'src/app/services/rest.service';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
    selector: 'survey-header',
    standalone: true,
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule,
        SharedModule
    ],
    templateUrl: './survey-header.component.html',
    styleUrl: './survey-header.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class SurveyHeaderComponent{
    public logo: InputSignal<any> = input(null);
    public languages: InputSignal<any[]> = input([]);
    public surveyName: InputSignal<any> = input(null);
    public isModal: InputSignal<boolean> = input(false);
    private modalController = inject(ModalController);
    public translate = inject(TranslateService);
    public rest = inject(RestService);
    public currentLang = signal(this.translate.currentLang);
    public surveyStyle: any;

    changeLanguage(lang) {
        this.translate.setDefaultLang(lang);
        this.translate.use(lang);
        this.currentLang.set(lang);
    }

    dismissModal(){
        this.modalController.dismiss();
    }
}